import React from "react"
import persistentUniqueId from "../utils/persistentUniqueId"

const Form = persistentUniqueId("uniqueId")(
    ({
        uniqueId,
        children,
        type,
        autocomplete,
        valid,
        inline,
        small,
        name,
        onChange,
        hasData,
        error,
        large
    }) => {
        return (
            <div
                className={
                    inline ? "form-karwei--inline" + (small ? "-small" : "") : ""
                }
            >
                <div
                    className={
                        "form-karwei " + (valid ? "is--valid" : error ? "is--invalid" : "")
                    }
                >
                    {large &&
                        <textarea 
                            name={name}
                            autoComplete={autocomplete || ""}
                            id={uniqueId("input")}
                            className={"form-karwei__input has--value"}
                            onChange={onChange}
                        />}

                    {!large &&
                        <input
                            name={name}
                            type={type || "text"}
                            autoComplete={autocomplete || ""}
                            id={uniqueId("input")}
                            maxLength="191"
                            className={"form-karwei__input " + (hasData && "has--value")}
                            onChange={onChange}
                        />}
                    <label htmlFor={uniqueId("input")} className="form-karwei__label">
                        {children}
                    </label>
                    {!large && <span className="form-karwei__indicator"></span>}
                </div>
                {error && !valid && <p className="form-karwei__error-text">{error}</p>}
            </div>
        )
    }
)

export default Form
